import {useState, useCallback} from 'react'
import axios from 'axios'
import {API_ENDPOINTS} from '../constants/apiConstants'
import {ApiResponseModel} from '../entities/entities'

export interface AdminRawBillingItem {
  doctor_id: number
  doctor_uuid: string
  doctor_name: string
  doctor_email: string
  patient_id: number
  uuid: string
  full_name: string
  cycle_start: string
  cycle_end: string
  dob: string
  care_minutes: string | number
  readings: number
  cpt_99453: boolean
  cpt_99454: boolean
  cpt_99457: boolean
  cpt_99458: number
}

export interface AdminBillingItem extends AdminRawBillingItem {}

export function useAdminBillingReport(initialMonthYear: string) {
  const [data, setData] = useState<AdminBillingItem[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchReport = useCallback(
    async (monthYear: string, doctorId?: number) => {
      setLoading(true)
      setError(null)
      try {
        const queryParams = new URLSearchParams()
        if (monthYear) {
          queryParams.append('month_year', monthYear)
        }
        if (doctorId) {
          queryParams.append('doctor_id', doctorId.toString())
        }

        const res = await axios.get<ApiResponseModel<{billingData: AdminRawBillingItem[]}>>(
          API_ENDPOINTS.GET_ADMIN_BILLING_REPORT(queryParams.toString())
        )

        const billingData = (res.data.data.billingData ?? []).map((item) => ({
          ...item,
          Patient: {
            dob: item.dob,
          },
        }))
        setData(billingData)
      } catch (e: any) {
        const msg = e.response?.data?.message || e.message
        setError(msg)
      } finally {
        setLoading(false)
      }
    },
    []
  )

  return {data, loading, error, fetchReport}
}


